var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContraindicationsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0746 2.92548C13.174 -0.975162 6.82642 -0.975162 2.92577 2.92548C-0.975258 6.82652 -0.975258 13.1733 2.92577 17.0743C4.8759 19.0245 7.43824 20.0003 10.0002 20.0003C12.5621 20.0003 15.1241 19.0248 17.0746 17.0743C20.9753 13.1733 20.9753 6.82613 17.0746 2.92548ZM3.46987 3.46958C5.27032 1.66914 7.63525 0.76872 10.0002 0.76872C12.2443 0.76872 14.4826 1.58987 16.2446 3.211L3.21167 16.2439C-0.117939 12.6257 -0.0386717 6.97812 3.46987 3.46958ZM16.5305 16.5298C13.0216 20.0388 7.37436 20.118 3.75577 16.788L16.7887 3.75548C20.1187 7.37369 20.0394 13.0213 16.5305 16.5298Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContraindicationsIcon);
export default __webpack_public_path__ + "static/media/ContraindicationsIcon.6ec4e223.svg";
export { ForwardRef as ReactComponent };